import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export function useOnSiteStructureChanged(siteId?: number) {
  const queryClient = useQueryClient();

  return useCallback(() => {
    const siteScope = siteId === undefined ? [] : [{ siteId }];

    queryClient.invalidateQueries({ queryKey: ["siteWizard", ...siteScope] });
    queryClient.invalidateQueries({ queryKey: ["energyWizard", ...siteScope] });
    queryClient.invalidateQueries({
      queryKey: ["operatorChanges", ...siteScope]
    });
    queryClient.invalidateQueries({
      queryKey: ["tenantChanges", ...siteScope]
    });
    queryClient.invalidateQueries({
      queryKey: ["premium-metering-concept-sketch-data", ...siteScope]
    });
  }, [queryClient, siteId]);
}
